var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModuleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.958,
    height: 25.163,
    viewBox: "0 0 24.958 25.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(-1022.542 -497.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M1046.5,510.523a11.479,11.479,0,1,1-11.479-11.581,11.531,11.531,0,0,1,11.479,11.581",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#f85",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M1045.046,526.964V519.9c0-.39.441-.707.984-.707s.984.317.984.707v7.067c0,.39-.44.707-.984.707s-.984-.317-.984-.707",
    transform: "translate(-11.009 -10.367)",
    fill: "#f85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M1047.009,513.144a1.1,1.1,0,1,1-1.1-1.047,1.075,1.075,0,0,1,1.1,1.047",
    transform: "translate(-10.888 -6.735)",
    fill: "#f85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleIcon);
export default __webpack_public_path__ + "static/media/moduleIcon.22725aba3d117c3a8935f88ca027d90e.svg";
export { ForwardRef as ReactComponent };